<div class="approver-node-container">
  <div class="approver-node">
    <div class="avatar">{{ (approver?.user?.name || documentNode?.content || 'A').charAt(0) }}</div>
    <div class="details">
      <div class="name">{{ approver?.user?.name || documentNode?.content || 'Unassigned approver' }}</div>
      @if (approver?.user?.email) {
        <div class="meta">{{ approver.user.email }}</div>
      }
    </div>
  </div>
  @if (editMode && !isAssignedCurrentUser) {
    <div class="approver-actions">
      <button mat-mini-fab color="primary" matTooltip="Edit approver" aria-label="Edit approver" (click)="editApprover()">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-mini-fab color="warn" matTooltip="Remove approver" aria-label="Remove approver" (click)="removeApprover()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  }
  @if (canApprove) {
    <div class="approver-approve">
      <button mat-raised-button color="primary" class="approve-button" (click)="onApproveClick()">
        <mat-icon>check_circle</mat-icon>
        <span>Approve</span>
      </button>
    </div>
  } @else if (hasApproved) {
    <div class="approver-approve approved-badge">
      <mat-icon>verified</mat-icon>
      <div class="approved-text">
        <span class="approved-label">Approved</span>
        <span class="approved-date">{{ approvalDate | date: 'dd.MM.yyyy HH:mm' }}</span>
      </div>
    </div>
  }
  @if (documentNode.comments?.length > 0) {
    @for (comment of documentNode.comments; track comment) {
      <app-comment-rail [nodeId]="documentNode?.id" [reviewerMode]="false" [comment]="comment"></app-comment-rail>
    }
  }
</div>
